import { useContext, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import localstorage from '../../services/storage/localstorage.ts';
import { STORE_LAST_MONTH_USER_VISITS } from '@utils/constants.ts';
import { updateUserVisitsData } from '@/utils';
import i18next from 'i18next';
import { LOOKBOOK_PARAMETERS_TO_COPY } from '../../pages/Lookbook/contants.ts';
import { logPageViewMetric } from '@/tracing/events.ts';
import { useAnalytics } from '@moment/analytics/AnalyticsProvider.tsx';
import { CommonPageDataContext } from '@pages/Root/ContextWrapper/WithInterest/CommonPageDataContext.ts';

export const UserTracker = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const analytics = useAnalytics();
  const context = useContext(CommonPageDataContext);

  useEffect(() => {
    const visitList = localstorage?.get(STORE_LAST_MONTH_USER_VISITS);
    if (!visitList || visitList.length == 0) {
      console.debug(`Initial visit for user`);
      analytics.emitFirstViewEvent({
        partnerId: context.partner || '',
        page: location.pathname,
        searchParams,
      });
    }
    updateUserVisitsData();
  }, []);

  const handleLocationChange = (loc: Location) => {
    const pathName = loc.pathname;
    let eventData: Record<string, string> = {
      page_path: pathName,
      language: i18next.language,
    };
    // add needed querystring params to event dat
    try {
      const params = new URLSearchParams(loc.search);
      for (const [key, value] of params) {
        if (LOOKBOOK_PARAMETERS_TO_COPY.includes(key)) {
          eventData[key] = value;
        }
      }
    } catch (e) {
      console.error(`Error parsing querystring params`, e);
    }
    // if lookbook or stories, parse info from URL
    if (pathName.startsWith('/lookbook/')) {
      eventData = {
        ...eventData,
        primary_interest: pathName.split('/')[2],
        page_path: '/lookbook',
        page_number: loc.hash,
      };
    } else if (pathName.startsWith('/stories/')) {
      eventData = {
        ...eventData,
        primary_interest: pathName.split('/')[2],
        page_path: '/stories',
      };
    }
    logPageViewMetric(eventData);
  };

  useEffect(() => {
    handleLocationChange(location);
  }, [location]);

  return <div id="user-tracker">{children}</div>;
};

export default UserTracker;
